import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { IssueType } from './types.tsx';

type EntryPointParams = {
	sourceLink: string;
	retryTrigger: number;
	selectedIssueType: IssueType;
	onAllSuggestionsActioned?: () => void;
};

export const BacklogAiWorkCreationPanelEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-backlog-ai-work-creation-panel" */ './ui').then(
			(module) => module.BacklogAiWorkCreationPanelEntryPointComponent,
		),
	),
	getPreloadProps: ({
		sourceLink,
		retryTrigger,
		selectedIssueType,
		onAllSuggestionsActioned,
	}: EntryPointParams) => ({
		extraProps: {
			sourceLink,
			retryTrigger,
			selectedIssueType,
			onAllSuggestionsActioned,
		},
	}),
});
